














































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SieMeta from '@/views/SieMeta.vue';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import { CompanySie } from '../store/models';

@Component({components: {SieMeta}})
export default class CardSie extends CompanyMixin {
    selectedModel: any = {};

    @Watch('sies', { immediate: true, deep: true })
    onSiesChanged() {
        if (this.sies && !this.selected) {
            if (user.selectedSie) {
                for (const sie of this.sies) {
                    if (sie.SieId === user.selectedSie) {
                        this.selectedModel = sie;
                        break;
                    }
                }
            } else if (this.sies.length > 0) {
                this.selectedModel = this.sies[0];
            }
        }

        if (user.activeSie && this.selected &&
            user.activeSie.SieId === this.selected.SieId &&
            user.activeSie.Id !== this.selected.Id) {
            user.setActiveSie(this.selected);
        }
    }

    @Watch('selected', { immediate: true, deep: true })
    async onSelectionChanged() {
        if (this.selected) {
            await user.setSelectedSie(this.selected.SieId);
            await user.setSelectedSieBlob(this.selected.Id);
        }
    }

  activateSie() {
    if (this.isActive) {
      user.setActiveSie(null);
    } else {
      user.setActiveSie(this.selected);
    }
  }

  editSie() {
      if (!this.selected) {
          return;
      }
      this.$router.push({name: 'editsie'});
  }

  get selected(): CompanySie | null {
    if (this.selectedModel.Created) {
      return this.selectedModel;
    } else {
      return null;
    }
  }

  get isActive() {
    if (!this.selected || !user.activeSie) {
        return false;
    }
    return this.selected.AggVersion === user.activeSie.AggVersion;
  }
}
